import { gql, useQuery } from "@apollo/client";

const GetBulkClassRoomCreationIntentQuery = gql`
  query getBulkClassRoomCreationIntent($id: String!) {
    getBulkClassRoomCreationIntent(id: $id) {
      id
      createdAt
      startDate
      numberOfWeeks
      maxClassRoomNumber
      user1on1ClassroomPlanToBeRedeemedId
      excludedSlots
      additionalSlots {
        startDateUtc
        endDateUtc
      }
      teacher {
        id
        givenName
        familyName
      }
      user {
        id
        givenName
        familyName
      }
      weekSlots {
        dayOfWeek
        startTime
        endTime
      }
    }
  }
`;

type IntentResult = {
  getBulkClassRoomCreationIntent: {
    id: string;
    createdAt: string;
    startDate?: string | null;
    numberOfWeeks?: number | null;
    maxClassRoomNumber?: number | null;
    user1on1ClassroomPlanToBeRedeemedId?: string | null;
    excludedSlots?: string[] | null;
    additionalSlots?: { startDateUtc: string; endDateUtc: string }[] | null;
    teacher?: { id: string; givenName: string; familyName: string } | null;
    user?: { id: string; givenName: string; familyName: string } | null;
    weekSlots?:
      | { dayOfWeek: number; startTime: string; endTime: string }[]
      | null;
  };
};

export function useGetBulkClassRoomCreationIntent(id: string) {
  const { data, loading, error } = useQuery<IntentResult>(
    GetBulkClassRoomCreationIntentQuery,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    intent: data?.getBulkClassRoomCreationIntent,
    loading,
    error,
  };
}
